// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#resolve-conflicts[data-v-7fd0186f]{display:flex;position:fixed;z-index:10000;bottom:0;max-width:900px;width:100vw;margin:auto;padding:20px 0}#resolve-conflicts button[data-v-7fd0186f]{margin:auto;box-shadow:0 0 10px var(--color-box-shadow)}\n", ""]);
// Exports
module.exports = exports;
